export function contactsExportFilename(jobId, entityType) {
  if (entityType === 'owners') {
    return `importer-owners-${jobId}.xls`;
  }
  return `importer-contacts-${jobId}.xls`;
}

// Browsers start blob downloads asynchronously; revoking in the same turn can
// cancel the save (notably in Safari).
const REVOKE_OBJECT_URL_DELAY_MS = 1000;

export function triggerBlobDownload(blob, filename) {
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(href), REVOKE_OBJECT_URL_DELAY_MS);
}
